import { datepicker } from './datepicker';

export function booking() {
    function bookingFilters($) { // booking panel wpf product filters
        $("#booking__panel .wpfMainWrapper")
            .addClass('booking__panel')
            .append('<div class="booking__inputGroup"></div>');
        //$("#booking__panel .wpfMainWrapper").addClass('booking__inputGroup');
        // input__inner
        let selects = [$("#booking__panel #wpfBlock_1"), $("#booking__panel #wpfBlock_2")];

        selects.forEach(el => {
            el.addClass('input');
            el.find(".wpfFilterContent").addClass("input__inner");
            el.find(".wpfCheckboxHier").addClass("choices");
            el.find("select").addClass("choices__inner");
            el.find("option").css('color', 'var(--black)');
            el.appendTo("#booking__panel .wpfMainWrapper .booking__inputGroup");
            // Set default attr test, not aplickable, need pro version, or different filtering flow
            // el.find('select option:last').attr('selected', 'true')
        });

        // Temp appending inputBlocks Temp!!!
        $(".booking__inputBlocks").appendTo("#booking__panel .wpfMainWrapper");

        let filterButton = $("#booking__panel .wpfFilterButton");
        filterButton.removeClass("wpfButton");
        filterButton.addClass("ssBtn ssBtn_primary _lg booking__submitBtn");
        //filterButton.appendTo("#booking__panel");
    }

    async function bookigFiltersRedirect(button) {
        var urlParams = new URLSearchParams(window.location.search);
        var pathName = window.location.pathname.replace(/\//g, '');
        let shopUrl = new URL('shop', window.location.origin);
        let bookingPanel = document.getElementById("booking__panel-wrapper");

        if (urlParams.has('wpf_fbv') /*&& pathName != 'shop'*/) {

            urlParams.forEach((value, key) => {
                shopUrl.searchParams.set(key, value);
            })

            //product_tag_0 wpf_filter_cat_1
            let data = {cat: urlParams.get('wpf_filter_cat_1'), tag: urlParams.get('product_tag_0')}

            wp.ajax.post( 'booking_product_search', data )
                .done(function(response) {
                    console.log("Done", response);
                    button.attr('href', response[0]);
                    bookingPanel.innerHTML = response[1];
                    button.css('z-index', 0);

                    bookigFiltersSetupForm(bookingPanel);
                })
                .fail(function(response) {
                    console.log("Fail", response);
                    button.attr('href', shopUrl.href + "#filters" );
                });
            //window.location.href = shopUrl.href;
        } else {
            button.attr('href', shopUrl.href + "#filters" );
        }

    }

    function bookigFiltersSetupForm(panel) {
        let form = panel.querySelector("form");
        let attrSelects = form.querySelectorAll('.input__select');
        let variationInput = form.querySelector('input[name="variation_id"]');
        let attributesData = (form.dataset.product_variations) ? JSON.parse(form.dataset.product_variations) : {};
        let dateSelect = form.querySelector("#ticket_datetime");
        let arr = [];
        let filters = {};

        let formPrice = form.querySelector(".price");
        let formCurrency = formPrice.querySelector(".woocommerce-Price-currencySymbol").innerHTML; //woocommerce-Price-currencySymbol
        if (formPrice.childElementCount > 1) formPrice.innerHTML = '';

        attrSelects.forEach(el => {
            el.addEventListener('change', e => {
                filters[e.target.dataset.attribute_name] = e.target.value;

                arr = attributesData.filter(item => {
                    return Object.keys(filters).every(filter => {
                        return filters[filter] === item.attributes[filter];
                    });
                });

                if (arr.length == 1) { // > 0
                    variationInput.value = arr[0].variation_id;

                    formPrice.innerHTML = arr[0].display_price + formCurrency;
                } else variationInput.value = 0;

            });
        });

        datepicker();
    }

    jQuery(document).ready(function($) {
        $('.wpfMainWrapper').attr('data-nowoo', '');
        bookingFilters($);
        // Providing redirect to shop page from other pages when performs search
        bookigFiltersRedirect($('#bookingFiltersBtn'))

        var urlParams = new URLSearchParams(window.location.search);
        let filterCats = document.querySelectorAll("[data-catfilterid]");

        if (filterCats.length > 0 && urlParams.has('wpf_fbv') && urlParams.has('wpf_filter_cat_1')) {
            filterCats.forEach(el => {
                el.classList.remove("_active");

                if (el.dataset.catfilterid == urlParams.get('wpf_filter_cat_1')) el.classList.add("_active");
            });
        }

        //$("#filters .wpfMainWrapper").addClass('filters__list');
    });
}